import { NotFound } from '@/pages/NotFound';
import { Routes, Route } from 'react-router-dom';
import MutationOverlay from '../components/MutationOverlay';
import { useTitle } from '@/hooks/useTitle';
import { useMemo } from 'react';
import UnsupportedBrowser from '@/pages/UnsupportedBrowser';
import { useIsSupportedBrowser } from '@/hooks/useIsSupportedBrowser';
import UnauthenticatedLayout from '@/components/layouts/UnauthenticatedLayout';
import { UnauthenticatedRoutes } from '@/routes/UnauthenticatedRoutes';
import { AuthenticatedRoutes } from '@/routes/AuthenticatedRoutes';
import { useAuthUser } from '@/hooks/stores/useAuthUser';
import { StaffRoutes } from '@/routes/StaffRoutes';

export default function App() {
  const { isStaff } = useAuthUser();
  useTitle(`SKYVIEW 1 ${isStaff ? 'Staff' : 'Advisor'} Dashboard`);
  const isSupportedBrowser = useMemo(useIsSupportedBrowser, []);

  if (!isSupportedBrowser) {
    return (
      <Routes>
        <Route element={<UnauthenticatedLayout />}>
          <Route path="*" element={<UnsupportedBrowser />} />
        </Route>
      </Routes>
    );
  }

  return (
    <>
      <MutationOverlay />
      <Routes>
        <Route>
          {UnauthenticatedRoutes}
          {AuthenticatedRoutes}
          {isStaff && <>{StaffRoutes}</>}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}
